export const startPerformanceMonitoring = () => {
  if (typeof window === "undefined" || !("PerformanceObserver" in window)) {
    return;
  }

  try {
    const longTaskObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.duration >= 50) {
          console.warn("[perf] long task", {
            duration: Math.round(entry.duration),
            startTime: Math.round(entry.startTime),
            name: entry.name,
          });
        }
      });
    });

    longTaskObserver.observe({ entryTypes: ["longtask"] });
  } catch {
    // Some browsers do not expose longtask entries.
  }

  performance.mark("app-bootstrap-start");
};

export const logWebVital = (metric) => {
  console.info("[web-vital]", {
    name: metric.name,
    value: Math.round(metric.value),
    rating: metric.rating,
    id: metric.id,
  });
};
